import { ScrollView, StyleSheet } from 'react-native';

import { tokens } from '@fhs/ui';
import { CHECKOUT_SCROLL_VIEW } from '@fhs-legacy/frontend/src/utils/test-ids';

import CheckoutActionButton from '../components/checkout-components/checkout-action-button';
import CheckoutSavingsBanner from '../components/checkout-components/checkout-savings-banner';
import { CheckoutOrderSummary } from '../components/checkout-components/order-summary';
import CheckoutPaymentDetails from '../components/checkout-components/payment-details';
import ServiceModeDetails from '../components/checkout-components/service-mode-details';

export function CheckoutScreen() {
  return (
    <>
      <ScrollView
        testID={CHECKOUT_SCROLL_VIEW}
        style={styles.scrollView}
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={false}
        keyboardShouldPersistTaps="handled"
      >
        <ServiceModeDetails />
        <CheckoutPaymentDetails />
        <CheckoutOrderSummary />
        <CheckoutSavingsBanner />
      </ScrollView>
      <CheckoutActionButton />
    </>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
    paddingBottom: 20,
  },
  flex1: {
    flex: 1,
  },
  list: {
    gap: 16,
  },
  subtotalContainer: {
    backgroundColor: tokens.colors.$houseLight,
    width: '100%',
    height: 48,
  },
  subtotalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});
